<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات دسته بندی مقاله"
        >
          <b-form
              ref="blogcategoryform"
              @submit.prevent
          >
            <b-row>

              <b-col
                  class="mt-2"
                  md="8"
                  offset-md="2"
              >
                <b-row>

                  <b-col
                      class="image"
                      cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                            ref="previewEl"
                            :src="Form.Image"
                            size="90px"
                            rounded
                            button
                            @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                          :ref="'refInputEl'"
                          type="file"
                          class="d-none"
                          name="Image"
                          @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                              label="عنوان"
                              label-for="Title"
                              class="mb-0"
                          >
                            <b-form-input
                                id="Title"
                                v-model="Form.Title"
                                name="Title"
                                autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="عنوان لاتین منحصر به فرد"
                        label-for="LatinTitle"
                    >
                      <div class="form-label-group">
                        <b-form-input
                            id="LatinTitle"
                            v-model="Form.LatinTitle"
                            name="LatinTitle"
                            autocomplete="off"
                        />
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="نوع"
                        label-for="Type"
                        class="mb-0"
                    >
                      <v-select
                          v-model="Form.Type"
                          :options="enums('Company')"
                          dir="rtl"
                          label="text"
                          :clearable="false"
                          :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="وضعیت"
                        label-for="IsDeactive"
                    >
                      <v-select
                          v-model="Form.IsDeactive"
                          :options="enums('IsDeactive')"
                          dir="rtl"
                          label="text"
                          :reduce="x => x.value"
                          :clearable="false"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                        label="توضیحات"
                        label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-input
                            id="Description"
                            v-model="Form.Description"
                            name="Description"
                            autocomplete="off"
                        />
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col v-if="editing" class="mt-1">
                    <b-row v-for="(item, index) in languages" :key="index" class="mb-1 border p-1 m-0">
                      <b-col md="10" class="">
                        <b-row>
                          <b-col md="4">
                            <b-form-group
                                label="زبان"
                            >
                              <z-language
                                  v-model="item.Language"
                                  :unselectable="languages.map(i => i.Language)"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="8">
                            <b-form-group
                                label="عنوان"
                            >
                              <b-form-input
                                  id="Title"
                                  v-model="item.Title"
                                  name="Title"
                                  autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="2" class="d-flex align-items-center justify-content-center">
                        <b-button v-if="deleting === item.Language" class="btn-icon" size="sm" @click="deleting = null">
                          <feather-icon icon="XIcon" />
                        </b-button>
                        <template v-else>
                          <b-button v-if="item.new" variant="primary" class="btn-icon mr-1" size="sm" @click="updateLanguage(item)">
                            <feather-icon icon="PlusIcon" />
                          </b-button>
                          <b-button v-else variant="primary" class="btn-icon mr-1" size="sm" @click="updateLanguage(item)">
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                        <b-button v-if="deleting === item.Language" variant="danger" class="btn-icon ml-1" size="sm" @click="removeLanguage(item, index)">
                          <feather-icon icon="CheckIcon" />
                        </b-button>
                        <b-button v-else variant="danger" class="btn-icon" size="sm" @click="deleting = item.Language">
                          <feather-icon icon="Trash2Icon" />
                        </b-button>
                      </b-col>
                    </b-row>
                    <div class="d-flex justify-content-center">
                      <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="gradient-info"
                          @click="addBlogCategoryLanguage"
                      >
                        <feather-icon
                            icon="PlusIcon"
                            class="mr-25"
                        />
                        <span>افزودن</span>
                      </b-button>
                    </div>
                  </b-col>
                  <b-col md="12" class="mt-3 text-center">
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        type="submit"
                        variant="primary"
                        class="mr-1"
                        @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                        variant="outline-secondary"
                        @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  name: 'BlogCategoryDetails',
  components: {},
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Image: null,
        Description: null,
        LatinTitle:null
      },
      loading: false,
      languages: [],
      language: {
        BlogCategoryId: this.$route.params.id,
        Language: null,
        Title: '',
        new: true
      },
      deleting: null
    }
  },
  computed: {
    editing() {
      return this.$route.params.id
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.blogcategory.add
      if (this.$route.params.id) {
        url = this.$api.blogcategory.update
      }

      const formData = new FormData()
      formData.append('Id', this.Form.Id)
      formData.append('Title', this.Form.Title)
      formData.append('LatinTitle', this.Form.LatinTitle)
      formData.append('Description', this.Form.Description)
      formData.append('Image', this.Form.Image)
      formData.append('Type', this.Form.Type)
      formData.append('IsDeactive', this.Form.IsDeactive)

      this.loading = true
      this.$http.post(url, formData)
          .then(() => {
            this.back()
          })
          .finally(() => {
            this.loading = false
          })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.blogcategory.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data
            this.languages = res.data.CategoryLanguageList.map(item => {
              return {
                ...item,
                BlogCategoryId: res.data.Id,
              }
            })
          })
    },
    updateLanguage(item) {
      let data = { ...item }
      delete data.new
      for (let i in data) {
        if (data[i] === '' || data[i] === null || data[i].length === 0)
          return this.$bvToast.toast('لطفا همه فیلد ها را پر کنید', {
            title: 'خطا در انجام عملیات',
            toaster: 'b-toaster-bottom-right',
            variant: 'danger',
            solid: false,
            appendToast: true,
          })
      }
      this.loading = true
      let url = item.new ? this.$api.blogcategory.addLanguageInfo : this.$api.blogcategory.editLanguageInfo
      this.$http.post(url, data)
          .then(() => {
            this.loading = false
            item.new = false
          }).catch(() => {
        this.loading = false
      })
    },
    removeLanguage(item, index) {
      if (item.new) return this.languages.splice(index, 1)
      this.loading = true
      this.$http.post(
          this.$api.blogcategory.removeLanguageInfo, { BlogCategoryId: this.editing, Language: item.Language },
      ).then(() => {
        this.loading = false
        let index = this.languages.findIndex(i => i.Language === item.Language)
        if (index !== -1) this.languages.splice(index, 1)
      }).catch(() => {
        this.deleting = null
        this.loading = false
      })
    },
    addBlogCategoryLanguage() {
      this.languages.push({ ...this.language })
    }
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
